import { ERROR_MESSAGES, ERROR_TYPES } from '../../../../lib/constants/errors';

export const getErrorMessage = (
  errorId: string,
  t: (descriptor: object, values?: object) => string
) => {
  switch (errorId) {
    case ERROR_TYPES.INVALID_IBAN:
      return t({id: ERROR_MESSAGES.INVALID_IBAN})
    default:
      return t({id: ERROR_MESSAGES.OTHER})
  }
}